import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'et',
    fullName: 'Estonian',
    nativeName: 'Eesti',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Midagi hämmastavat on tulemas",
    landing_subtitle: "ArgVoid on rakenduste ja mängude arendusstuudio. Püsige lainel, peagi on tulemas uusi asju!",
    select_language: "Valige keel",
    search_placeholder: "Otsi keeli...",
    terms_title: "Kasutustingimused",
    policy_title: "Privaatsuspoliitika",
    cookies_title: "Küpsiste poliitika",
    terms_content: `
        <strong>1. Tingimustega nõustumine</strong><br>
        ArgVoidile juurdepääsuga nõustute nende teenusetingimustega. Kui nende tingimustega ei nõustuta, ei tohiks teenust kasutada.<br><br>

        <strong>2. Platvormi kasutamine</strong><br>
        ArgVoidi ja selle rakendusi pakutakse informatiivsel ja loomingulisel eesmärgil "nagu on". Teenust tohib kasutada ainult seaduslikel eesmärkidel.<br>X<br>

        <strong>3. Keelatud käitumine</strong><br>
        Saidi haavatavuste ärakasutamine, rämpsposti saatmine või volitamata juurdepääsu katse infrastruktuurile on rangelt keelatud.<br><br>

        <strong>4. Kohustustest loobumine</strong><br>
        Platvormi ja teenuseid võidakse igal ajal ilma ette teatamata muuta. Teenuse tööaja ega saadavuse osas garantiid ei anta.
    `,
    policy_content: `
        <strong>1. Teabekogu</strong><br>
        Platvorm ei nõua praegu kasutaja autentimist ega konto loomist. Külastajatelt ei koguta aktiivselt isikut tuvastavat teavet (nt nimesid või e-posti aadresse).<br><br>

        <strong>2. Kasutusandmed</strong><br>
        Saidi liikluse mõistmiseks ja rakenduste täiustamiseks võidakse koguda anonüümseks muudetud põhianalüüse. Need andmed ei ole seotud üksikute kasutajaidentiteetidega.<br>X<br>

        <strong>3. Kolmanda osapoole teenused</strong><br>
        Kolmandast osapoolest teenusepakkujaid võidakse kasutada hostimis- ja analüüsiteenuste jaoks. Nende vastavate pakkujate privaatsustavad reguleerivad nende infrastruktuuris töödeldavaid anonüümseid andmeid.<br><br>

        <strong>4. Andmeturve</strong><br>
        Platvormi kaitsmiseks rakendatakse mõistlikke turvameetmeid. Ükski Interneti kaudu edastamise viis ei ole siiski täiesti turvaline.<br><br>
    `,
    cookies_content: `
        <strong>1. Mis on küpsised ja kohalik salvestusruum?</strong><br>
        Küpsised ja brauseri kohalik salvestusruum on väikesed andmefailid, mis salvestatakse seadmesse, et meeles pidada külastuste konfiguratsioonieelistusi.<br><br>

        <strong>2. Kasutuseesmärk</strong><br>
        Brauseri LocalStorage'i kasutatakse rangelt konfiguratsiooniseadete salvestamiseks, näiteks:<br>
        - Keele-eelistused<br>
        - Kasutajaliidese konfiguratsioon (nt paigutuse või teema seaded) <br>
        - Ajutine rakenduse vahemälu<br><br>

        <strong>3. Tracking</strong><br> puudub
        Küpsiseid ja kohalikku salvestusruumi ei kasutata reklaami või kolmanda osapoole jälgimise eesmärgil. Kõik salvestatud andmed on mõeldud rangelt platvormi põhifunktsioonide jaoks.<br><br>

        <strong>4. Control</strong><br>
        Brauseri andmeid saab igal ajal kustutada brauseri seadete kaudu, mis lähtestab kõik kohalikud konfiguratsioonid.
    `,
    cookie_consent_text: "Kasutame põhiküpsiseid, et tagada veebisaidi korrektne toimimine, näiteks teie seansi aktiivsena hoidmine, keele-eelistuse salvestamine ja muud kohandatud konfiguratsioonid.",
    read_policy: "Lugege küpsiste poliitikat",
    support_title: "Võtke ühendust tugiteenusega",
    support_subject_label: "Teema",
    support_message_label: "Sõnum",
    support_submit_button: "Saada Sõnum",
    support_hint: "Märkus. See avab teie vaikemeilirakenduse sõnumi saatmiseks.",
    support_success_msg: "Meilirakenduse avamine...",
    support_error_msg: "Sõnumi saatmine ebaõnnestus. Proovige hiljem uuesti.",
    explorer_title: "Explorer",
    history_title: "Ajalugu",
    animation_title: "Animatsioon",
    config_title: "Seadistamine",
    tool_mouse: "Vali (Ctrl+M)",
    tool_brush: "Pintsel (Ctrl+B)",
    tool_brush_mode: "Lülitage režiim (tahke/selge)",
    tool_eraser: "Kustutuskumm (Ctrl+E)",
    tool_brush_size: "Reguleerige pintsli suurust",
    tool_bucket: "Täida (Ctrl+F)",
    tool_eyedropper: "Pipetti",
    tool_grid: "Ruudustik (Ctrl + Tõstuklahv + B)",
    tool_rotate: "Pööra (Ctrl+Shift+R)",
    tool_flip_h: "Pööra H (Ctrl+Tõstuklahv+H)",
    tool_flip_v: "Pööra V (Ctrl+Shift+V)",
    tool_transpose: "Transponeeri (Ctrl+Shift+T)",
    label_width: "Laius",
    label_height: "Kõrgus",
    label_frames: "Kaadrite arv",
    label_animation: "Animatsiooni stiil",
    label_background_color: "Taustavärv",
    label_interval: "Intervall",
    tool_anim_config: "Animatsiooni konfiguratsioon",
    label_new_width: "Uus laius",
    label_new_height: "Uus kõrgus",
    label_apply: "Rakenda",
    label_colors: "Värvid",
    label_size: "Suurus",
    label_tolerance: "Tolerantsus",
    val_horizontal: "Horisontaalne",
    val_vertical: "Vertikaalne",
    val_sequence: "Jada",
    val_bounce: "Põrgatama",
    val_random: "Juhuslik",
    val_solid: "Tahke",
    val_clear: "Selge",
    action_add_sheet: "Uus leht",
    action_import: "Import",
    action_export: "Ekspordi",
    action_sort_projects: "Sorteeri",
    sort_date_old: "Vanim esimene",
    sort_date_new: "Kõige uuemad enne",
    sort_name_az: "Nimi (A-Z)",
    sort_name_za: "Nimi (Z-A)",
    action_new_sprite: "Uus Sprite",
    action_new_project: "Uus projekt",
    modal_save_all_title: "Salvesta kõik muudatused",
    modal_save_all_desc: "Valige salvestatavad varad:",
    modal_save_selected: "Salvesta valitud",
    action_saved: "Salvestatud",
    modal_create_sprite_title: "Looge uus Sprite",
    modal_create_project_title: "Loo uus projekt",
    modal_add_sheet_title: "Lisa uus leht",
    modal_rename_sheet_title: "Nimeta leht ümber",
    modal_rename_sprite_title: "Nimeta Sprite ümber",
    modal_delete_sprite_title: "Kustuta Sprite",
    modal_delete_project_title: "Kustuta projekt",
    modal_delete_sheet_title: "Kustuta leht",
    placeholder_sprite_name: "Nimi",
    placeholder_project_name: "Nimi",
    placeholder_sheet_name: "Nimi",
    placeholder_new_name: "Uus nimi",
    action_create: "Loo",
    action_add: "Lisa",
    action_rename: "Nimeta ümber",
    action_duplicate: "Duplikaat",
    action_delete: "Kustuta",
    action_cancel: "Tühista",
    confirm_delete_sprite: "Kas olete kindel, et soovite selle spraidi kustutada?",
    confirm_delete_project: "Kas olete kindel, et soovite selle projekti kustutada? Kõik spraidid eemaldatakse.",
    confirm_delete_sheet: "Kas olete kindel, et soovite selle lehe kustutada?",
    err_select_sprite: "Valige esmalt sprait.",
    err_select_project: "Valige esmalt projekt.",
    err_name_empty: "Nimi ei tohi olla tühi.",
    err_sprite_exists: "Selle nimega sprait on juba olemas.",
    err_project_exists: "Selle nimega projekt on juba olemas.",
    err_no_content: "Pole sisu, mida salvestada.",
    err_no_changes: "Salvestatavaid muudatusi pole.",
    err_delete_last_sheet: "Viimast lehte ei saa kustutada.",
    err_extract_frames: "Ühtegi kaadrit ei saanud ekstraktida.",
    err_indexeddb: "Kohalik salvestamine ebaõnnestus. Teie brauser ei pruugi toetada IndexedDB-d.",
    msg_upload_success: "Üleslaadimine õnnestus: {0}",
    msg_upload_failed: "Üleslaadimine ebaõnnestus: {0}",
    msg_save_success: "Salvestamine õnnestus.",
    msg_saving: "Salvestamine...",
    msg_multi_save_result: "Salvestatud {0} vara. {1} tõrget.",
    menu_title: "Menüü",
    menu_save: "Salvesta",
    menu_save_all: "Salvesta kõik",
    menu_support: "Võtke ühendust tugiteenusega",
    label_local_storage: "Kohalik salvestusruum",
    label_sign_in: "Logi sisse",
    modal_export_title: "Ekspordi Sprite",
    label_filename: "Failinimi",
    label_format: "Vorming",
    action_export_confirm: "Ekspordi",
};

export default translations;
